import { Card, Col, Icon, Row, Tag, Tooltip } from 'antd';
import * as React from 'react';
import { ShowImages } from 'src/components/ShowImages';
import { collectionsMapping, searchableAttributes, unsearchableAttributes } from 'src/mappings';
const uuid = require('uuid');
const moment = require('moment');

/**
 * Stateless Component that takes the query research parse the card dynamically based on the collection type
 *
 * @param data - query result
 *
 */
const ResultCard = ({ data, viewed, markAsViewed }: any) => {

  const allImages = data.images;
  let amendmentStatus: string = '';

  const visibleImages = data.images.filter( (image: any) => image.imageStatus == 'VISIBLE' );
  data.images = visibleImages;

  const dateCreated =
    data.dateCreated && moment(data.dateCreated).format('DD-MM-YYYY');
  const dateClosed =
    data.dateClosed && moment(data.dateClosed).format('DD-MM-YYYY');

  let counter = 0;

  const leftSideAttributes: any = [];
  const rightSideAttributes: any = [];
  let parentCollectionName: string = '';

  const attributesDisplayedOnCard = Object.assign({},
    searchableAttributes,
    { 16: unsearchableAttributes[16] },
    { 34: unsearchableAttributes[34] },
    { 12: unsearchableAttributes[12] }
  );

  if (collectionsMapping[data.collectionId]['SHOW_PARENT_COLLECTION']) {
    parentCollectionName = collectionsMapping[collectionsMapping[data.collectionId]['PARENT_COLLECTION_ID']].NAME;
  }

  Object.keys(attributesDisplayedOnCard).map((key, index)=>{

    const fieldName = attributesDisplayedOnCard[key].FIELD_NAMES[0];
    const displayName = attributesDisplayedOnCard[key].DISPLAY_NAME;

    let listItem;

    if (data[fieldName] && fieldName != 'imageName') {

      if (key.toString() == '45') {
        listItem =
          <li key={uuid.v4()}><strong>{displayName + ': '} </strong>
            <span dangerouslySetInnerHTML={{ __html: data['yearFrom'] + ' - ' + data['yearTo'] }}/>
          </li>;
      } else {

        listItem =
          <li key={uuid.v4()}><strong>{displayName + ': '} </strong>
            <span dangerouslySetInnerHTML={{ __html: data[fieldName] }}/>
          </li>;
      }
      if (counter % 2 == 0 ) {
        leftSideAttributes.push(listItem);
      } else {
        rightSideAttributes.push(listItem);
      }
      counter++;
    }
  });

  if (parentCollectionName) {
    const parentCollectionItem =
      <li key={uuid.v4()}>
        <strong>Parent Collection: </strong>
        <span dangerouslySetInnerHTML={{ __html: parentCollectionName }}/>
      </li>;
    leftSideAttributes.length > rightSideAttributes.length ?
      rightSideAttributes.push(parentCollectionItem) : leftSideAttributes.push(parentCollectionItem);
  }

  if (dateCreated) {
    const dateCreatedItem =
      <li key={uuid.v4()}>
        <strong>Date Created: </strong>
        <span dangerouslySetInnerHTML={{ __html: dateCreated }}/>
      </li>;
    leftSideAttributes.length > rightSideAttributes.length ?
      rightSideAttributes.push(dateCreatedItem) : leftSideAttributes.push(dateCreatedItem);
  }
  if (dateClosed) {
    const dateClosedItem =
      <li key={uuid.v4()}>
        <strong>Date Closed: </strong>
        <span dangerouslySetInnerHTML={{ __html: dateClosed }}/>
      </li>;
    leftSideAttributes.length > rightSideAttributes.length ?
      rightSideAttributes.push(dateClosedItem) : leftSideAttributes.push(dateClosedItem);
  }

  if (allImages) {
    for (let allImage of allImages) {
      if (allImage.imageStatus == "VISIBLE") {
        amendmentStatus = "";
        break;
      }
      if (allImage.imageStatus == "AMENDMENT_ACTION_PENDING") {
        amendmentStatus = "AMENDMENT_ACTION_PENDING";
      }
    }
  }

  return (
    <Card
      title={
        viewed ?
          <>
            <span style={{ color: 'grey' }}>{data.imageName}</span>
            <span style= {{ marginLeft: 10, verticalAlign: 'sub' }}>
              <Tooltip title='You have viewed this document.'>
                <Icon type='info-circle' theme='twoTone' twoToneColor='grey' style={{ fontSize: '1.6em' }}/>
              </Tooltip>
            </span>
          </>
        : <span>{data.imageName}</span>
      }
      key={data._id}
      actions={[
        <Tag color={viewed ? 'darkgrey' : 'blue'} key={data._id} style={{ cursor: 'default' }}>
          {data.collectionName}
        </Tag>,
        <ShowImages key={data._id} data={data} viewed={viewed} markAsViewed={markAsViewed}/>
      ]}
    >
      <h1 style={{ color:"red"}}> {amendmentStatus}</h1>
      <Row style={{ fontSize: '0.9em', color: viewed ? 'grey': '' }}>
        <Col span={12}>
          <ul>
            {leftSideAttributes}
          </ul>
        </Col>
        <Col span={12}>
          <ul>
            {rightSideAttributes}
          </ul>
        </Col>
      </Row>
    </Card>
  );
};

export default ResultCard;



// WEBPACK FOOTER //
// ./src/components/search/cards/ResultCard.tsx